export enum BookingFlowStatus {
  Init,
  Success,
  Error,
}

export enum BookingParamEnum {
  SUCCESS = 'exitoso',
  BOOKING = 'reserva',
  ERROR = 'error',
}
